import React from "react";

import EntityDetails from "./EntityDetails";
import ExecutiveDetails from "./ExecutiveDetails";
import AdminPage from "./AdminPage";

import { MDBContainer } from "mdb-react-ui-kit";
import EmployeeCard from "../components/Cards/EmployeeCard";
import EmployeePage from "./EmployeePage";

function Home({ userType, entityID, sidebarDiv, setSidebarDiv }) {
  // useEffect(() => {
  //   (async () => {
  //     const response = await fetch(
  //       config.domainName + ":" + config.port + "/api/employeequery",
  //       {
  //         method: "POST",
  //         headers: { "Content-Type": "application/json" },
  //         body: JSON.stringify({
  //           function: "AllEmployeeGrade",
  //         }),
  //       }
  //     );
  //   })();
  // }, []);

  return (
    <div id="mainDiv">
      {userType !== null &&
        (userType === 0 ? (
          <AdminPage sidebarDiv={sidebarDiv} setSidebarDiv={setSidebarDiv} />
        ) : userType === 1 ? (
          <ExecutiveDetails
            sidebarDiv={sidebarDiv}
            setSidebarDiv={setSidebarDiv}
          />
        ) : userType === 2 ? (
          <EntityDetails
            entityID={entityID}
            sidebarDiv={sidebarDiv}
            setSidebarDiv={setSidebarDiv}
          />
        ) : userType === 3 ? (
          <EmployeePage employeeQuery={"TZSGAADDA00052"} />
        ) : (
          ""
        ))}
    </div>
  );
}

export default Home;
